import { useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../../config';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      await fetch(`${config.API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      // fastapi-users always returns 202 here regardless of whether the
      // email exists, so we don't branch on the response -- show the same
      // message either way to avoid leaking which emails are registered.
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-black text-white justify-center items-center p-4">
      <div className="bg-gray-800 p-8 rounded-lg w-full max-w-md border border-blue-500 space-y-4">
        <h2 className="text-2xl font-bold text-center text-white mb-2">Forgot Password</h2>

        {submitted ? (
          <>
            <p className="text-gray-300 text-center">
              If an account exists for <span className="font-semibold">{email}</span>, we've sent a
              password reset link to it. The link expires in 1 hour.
            </p>
            <p className="text-sm text-center pt-2">
              <Link to="/creator-login" className="text-blue-400 hover:text-blue-300">
                Back to Login
              </Link>
            </p>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-gray-400 text-sm">
              Enter your account email and we'll send you a link to reset your password.
            </p>

            {error && (
              <div className="bg-red-900 border border-red-500 text-red-200 px-4 py-2 rounded">
                {error}
              </div>
            )}

            <input
              className="w-full p-2 bg-gray-900 border border-gray-600 rounded text-white placeholder-gray-400"
              type="email"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <button
              className="w-full bg-blue-500 text-white p-3 rounded-lg font-semibold hover:bg-blue-600 transition disabled:bg-gray-600"
              type="submit"
              disabled={submitting}
            >
              {submitting ? 'Sending...' : 'Send Reset Link'}
            </button>

            <p className="text-sm text-center">
              <Link to="/creator-login" className="text-blue-400 hover:text-blue-300">
                Back to Login
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
